module.exports = __webpack_public_path__ + "static/img_2618-df65f2bb0e1ddb3aa6d5fe88444d32f8.webp";